import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  Easing,
  TouchableHighlight,
  TextInput,
  Dimensions,
  ActivityIndicator,
  Image,
  Alert,
} from 'react-native';
import {StyleContext} from '../styleC';

import timezone from '../timezone';

import strings from '../strings';
import MavSelector from './mavSelector';
import MavAlert from './mavAlert';
import MavTextInput from './mavTextInput';
import MavButton from './mavButton';
import moneyList from '../moneyList';
import MavInfoBubble from './mavInfoBubble';

import Modal from './modal';

const timer = require('react-native-timer');





export default class account extends Component {
  constructor(props) {
    super(props);

    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;

    this.state = {
      extraEUMode:params.extraEUMode,
      viewAccurency:params.viewAccurency,
      viewAccurencyList:params.viewAccurencyList,
      enableTimezone:params.enableTimezone, 
      seeTimezone:false, 
      
    };
  }


  
  componentDidMount() {

    console.log("couc")
    

  }




  

  render() {

    let moneyListTotal=moneyList
    let timezoneTotal=timezone

    return (
      <StyleContext.Consumer>{style => 
      <ScrollView style={{flex:1,backgroundColor:style.backgroundColor}}>

          <MavInfoBubble type={"info"}  title={strings.internationalCustomer} subTitle={strings.conversationGestionMoreInfo} style={{marginTop:10,}} />


          {true && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.extraEUMode} textExplication={strings.extraEUMode} enableInfo={true} onEnableInfo={() => {this.alert.onAlert({title:strings.extraEUMode, subTitle:strings.extraEUModeMoreInfo}) }} onChange={()=>{
              var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;
              params.updateExtraEUMode(!this.state.extraEUMode) 
              this.setState({extraEUMode:!this.state.extraEUMode})
            }}/>}


            {true && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.enableTimezone} textExplication={strings.enableTimezone+  ((this.state.enableTimezone!=false)?(" ("+this.state.enableTimezone.text+")" ):"") } enableInfo={true} onEnableInfo={() => {this.alert.onAlert({title:strings.enableTimezone, subTitle:strings.enableTimezoneMoreInfo}) }} onChange={()=>{
                if(this.state.enableTimezone!=false) {
                  this.setState({enableTimezone:false})
                  var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;
                  params.updateEnableTimezone(false) 
                }
                else {
                    this.setState({seeTimezone:true})
                }


              
            }}/>}


            {true && <MavTextInput style={{marginTop:5}} textInputFlex={0.8} disabledText={true}  arrow={true} arrowEnabled={this.state.viewAccurency} textExplication={strings.viewAccurency} enableInfo={true} onEnableInfo={() => {this.alert.onAlert({title:strings.viewAccurency, subTitle:strings.viewAccurencyMoreInfo}) }} onChange={()=>{
              this.setState({viewAccurency:!this.state.viewAccurency});
              var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;
              params.updateViewAccurency(!this.state.viewAccurency) 
              
            }}/>}




            {this.state.viewAccurency==true && <Text style={{marginLeft:Dimensions.get('window').width * 0.1, marginRight:Dimensions.get('window').width * 0.1,marginTop:15,marginBottom:10, color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>{strings.selectDeviseToView}</Text>}


            {this.state.viewAccurency==true && moneyListTotal.map((countryListregion, key)=>( 

                <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => { var list=this.state.viewAccurencyList; if(list[countryListregion.id]==true) delete list[countryListregion.id]; else list[countryListregion.id]=true; this.setState({viewAccurencyList:list},() =>{ var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;params.updateViewAccurencyList(this.state.viewAccurencyList)   })  }}>
                            <View style={{flexDirection:"row", alignItems:"center", marginTop:5,marginLeft:Dimensions.get('window').width*0.1, marginRight:Dimensions.get('window').width*0.1}}>
                              <Image source={countryListregion.flag} style={{ height: 30,width:40, marginRight:10, }}/>
                              <Text style={{fontSize: style.textInputFontSize,color:style.textInputColor, width:(Dimensions.get('window').width*0.8)-140}}>{countryListregion[strings.idLangue]}</Text>
                              <Text style={{fontSize: style.textInputFontSize*1.7,color:style.colorValidate, width:90, textAlign:"right"}}>{(this.state.viewAccurencyList[countryListregion.id]==true)?"✓":""}</Text>
                            

                            </View>
                        </TouchableHighlight>

              ))}


            <MavAlert ref={alert => {this.alert = alert;}}/>
            <Modal animationType="none" transparent={true} visible={this.state.seeTimezone}>
              <View style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,position:"absolute", backgroundColor:style.backgroundColor}}>
                <Text style={{fontSize: style.textInputFontSize*1.5, textAlign:"center",marginTop:50, marginBottom:10}}>{"Selectionner"}</Text>
                <ScrollView style={{marginLeft:15, marginRight:15}}>
                      {timezoneTotal.map(elem => (
                          <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => {var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; this.setState({seeTimezone:false, enableTimezone:elem}); params.updateEnableTimezone(elem)   }}>
                              <MavTextInput style={{marginTop:5}} textRight={((elem.value>0)?"+":"")+elem.value+" UTC"} disabledText={true} textExplication={elem.text}/>
                          </TouchableHighlight>

                        ))}

                        <View style={{alignItems:"center",justifyContent:"center",marginTop:10}}>
                          <MavButton text={strings.return} onlyButton={true} style={{marginTop:20, marginBottom:20}} onPress={()=>{ this.setState({seeTimezone:false});  }}/>
                        </View>
                        
                      </ScrollView>
              </View>
            </Modal>

      </ScrollView>

      }</StyleContext.Consumer>
    );
  }
}

account.navigationOptions = ({ navigation, screenProps }) => {
  return {
    headerTitle: strings.international,
    headerTintColor: screenProps.headerColor,
    headerStyle: {
      backgroundColor: screenProps.headerBackgroundColor,
    },
  };
};


export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
